import Vue from "vue";
import "vue-googlemaps/dist/vue-googlemaps.css";
import VueGoogleMaps from "vue-googlemaps";
Vue.use(VueGoogleMaps, {
  load: {
    apiKey: "AIzaSyDdV0N9mTNuuHo-ABKnrUaHlSLx-je7yi0",
    libraries: ["places"],
  },
});
